import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import Card from "../Reusable/Card";
import { useForm } from "react-hook-form";
import ComboboxInput from "../Reusable/ComboboxInput";
import DeliveryChargeTable from "./DeliveryChargeTable";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import MultipleSelectField from "../Reusable/MultiSelectField";
import { getKey } from "../../helpers/sessionKey";
import CargoDeliveryChargeTable from "../CargoDeliveryCharge";
import useGetHook from "../../customHooks/useGetHook";

const DeliveryChargeList = (props: any) => {
  const { id, templateID } = useParams();
  const { defaultBranch } = props;
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({
    defaultValues: {
      local_branch: defaultBranch,
    },
  });
  const localServiceBranch = watch("local_branch");
  const localServiceType = watch("local_service");
  const localProductType = watch("product_type");
  const clientType = getKey("client-type");

  const branchId = localServiceBranch?.id || localServiceBranch;

  const { data: selectedBranch } = useGetHook({
    queryKey: ["branch", branchId],
    url: `${APIS.BRANCH}${branchId}/`,
    params: {},
    enabled: !!branchId,
  });
  const serviceTypeId = localServiceType?.id || localServiceType;

  const { data: selectedServiceType } = useGetHook({
    queryKey: ["service-type", serviceTypeId],
    url: `${APIS.SERVICE_TYPE}${serviceTypeId}/`,
    params: {},
    enabled: !!serviceTypeId,
  });

  return (
    <>
      <Card title={`Rate List`}>
        <div className={tw`w-full grid grid-cols-3 gap-x-6`}>
          <ComboboxInput
            url={APIS.BRANCH}
            props={{ is_active: true }}
            queryKey={"local-branch"}
            register={register("local_branch")}
            errors={errors?.local_branch}
            name={"local_branch"}
            label={"Service Branch"}
            setValue={setValue}
            placeholder={"Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{ is_active: true }}
            queryKey={"local-service"}
            register={register("local_service")}
            errors={errors?.local_service}
            name={"local_service"}
            label={"Service Type"}
            setValue={setValue}
            placeholder={"Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <MultipleSelectField
            label={"Product Type"}
            queryKey={"product-type"}
            register={register("product_type")}
            watch={watch}
            setValue={setValue}
            props={{
              is_active: true,
              ...(clientType === "cargo"
                ? {
                    is_shipment_type: true,
                  }
                : {
                    is_shipment_type: false,
                  }),
            }}
            url={APIS.PRODUCT_TYPE}
            value={[]}
          />
        </div>
      </Card>
      {clientType === "cargo" ? (
        <Card title={`Rate Format`}>
          {localServiceBranch &&
          localServiceType &&
          localProductType?.length !== 0 &&
          localProductType ? (
            <CargoDeliveryChargeTable
              localServiceBranch={localServiceBranch}
              localServiceType={localServiceType}
              localProductType={localProductType}
              merchantId={null}
              delivery_charge_template={templateID}
              id={id}
            />
          ) : (
            <>
              {" "}
              <p>Please select Service Branch And Service type</p>
            </>
          )}
        </Card>
      ) : (
        <Card title={`Rate Format`}>
          {localServiceBranch &&
          localServiceType &&
          localProductType?.length !== 0 &&
          localProductType ? (
            <DeliveryChargeTable
              localServiceBranch={localServiceBranch}
              localServiceType={localServiceType}
              localProductType={localProductType}
              merchantId={null}
              delivery_charge_template={templateID}
              selectedBranch={selectedBranch}
              selectedServiceType={selectedServiceType}
              id={id}
            />
          ) : (
            <>
              {" "}
              <p>Please select Service Branch And Service type</p>
            </>
          )}
        </Card>
      )}
    </>
  );
};

export default DeliveryChargeList;
